export default state => ({
  ...state,
  selection: [],
  errors: {},
  source: '',
  validationResults: {},
});
